<template>
  <div class="eventExhibition">
    <div class="eventExhibition-content-title">
      <div class="title-left">{{ lan ? 'Exhibit' : '展出作品' }}</div>
    </div>
    <div class="eventExhibition-act-list">
      <div
        class="carousel-exhibit"
        @mousedown="startDrag"
        @mouseup="endDrag"
        @mouseleave="endDrag"
        @touchstart="startDrag"
        @touchend="endDrag"
      >
        <div class="carousel-slides-exhibit" ref="slides" @touchmove="drag" @mousemove="drag">
          <div
            v-for="(slide, index) in showData"
            :key="index"
            :class="{ 'carousel-slide': true, active: currentIndex === index }"
          >
            <img class="exhibit-pc" :src="slide.src" alt="" />
          </div>
        </div>
      </div>
    
    </div>
    <div class="work-info">
      <div class="work-title">
        {{ showData[currentIndex] ? showData[currentIndex].title : '' }}
      </div>
      <div class="work-dec">
        <div v-for="(el, index) in (showData[currentIndex] ? showData[currentIndex].labelList : [])" :key="index">
          {{ el }}
        </div>
      </div>
      <div class="carousel-pagination">
        <div
          v-for="(_, index) in showData"
          :key="index"
          :class="{
            'carousel-pagination-button': true,
            active: currentIndex === index,
          }"
          @click="goToSlide(index)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentIndex: 0,
      startX: 0,
      dragging: false,
      threshold: 50,
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"(newVal) {
      this.lan = newVal;
    },
    showData: {
      handler() {
        // 数据更新时重置到第一张
        this.currentIndex = 0;
        this.updateSlidePosition();
      },
      deep: true
    }
  },
  mounted() {
    this.updateSlidePosition();
  },
  methods: {
    startDrag(event) {
      if (event.touches) {
        this.startX = event.touches[0].clientX;
      } else {
        this.startX = event.clientX;
      }
      this.dragging = true;
    },
    drag(event) {
      if (!this.dragging) return;
      event.preventDefault();
    },
    endDrag(event) {
      if (!this.dragging) return;
      let deltaX = 0;
      if (event.changedTouches) {
        deltaX = event.changedTouches[0].clientX - this.startX;
      } else {
        deltaX = event.clientX - this.startX;
      }
      
      if (Math.abs(deltaX) > this.threshold) {
        if (deltaX > 0) {
          this.prevSlide();
        } else {
          this.nextSlide();
        }
      }
      
      this.dragging = false;
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.showData.length;
      this.updateSlidePosition();
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex + this.showData.length - 1) % this.showData.length;
      this.updateSlidePosition();
    },
    goToSlide(index) {
      this.currentIndex = index;
      this.updateSlidePosition();
    },
    updateSlidePosition() {
      if (this.$refs.slides) {
        this.$refs.slides.style.transform = `translateX(-${100 * this.currentIndex}%)`;
      }
    }
  },
};
</script>

<style scoped>
.eventExhibition-act-list {
  position: relative;
}
.title-left {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: Bold;
  margin: 60px 0 20px;
}
.carousel-exhibit {
  width: 720px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.carousel-slides-exhibit {
  display: flex;
  width: 100%;
  transition: transform 0.5s ease;
  color: #000;
}
.carousel-slides-exhibit .exhibit-pc {
  width: 720px;
  height: 720px;
  object-fit: cover;
}

.carousel-slide {
  flex: 0 0 100%;
  min-width: 100%;
  text-align: center;
  padding: 20px 0;
}

.carousel-slide.active {
}

.carousel-pagination {
  display: flex;
  margin-top: 20px;
}

.carousel-pagination-button {
  margin: auto 4px !important;
  opacity: 1;
  width: 20px;
  height: 4px;
  background: url(../../assets/diandian_grey.png) no-repeat center;
  background-size: contain;
  cursor: pointer;
}

.carousel-pagination-button.active {
  width: 20px;
  height: 4px;
  background: none;
  position: relative;
  background: url(../../assets/diandian_highllight.png) no-repeat center;
  background-size: contain;
}

.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: #000;
  border: none;
  cursor: pointer;
  z-index: 10;
}
.work-info {
  width: auto;
  height: auto;
  text-align: left;
  position: absolute;
  left: 750px;
  bottom: 21px;
}
.work-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 34px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: Bold;
  margin-bottom: 11px;
}
.work-dec {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #2c2c2c;
  letter-spacing: 0;
  text-align: left;
  line-height: 32px;
  font-weight: Regular;
}
@media (max-width: 1440px) {
  .work-info {
  width: auto;
  height: auto;
  text-align: left;
  position: absolute;
  left: 750px;
  bottom: 55px;
}
  .eventExhibition-act-list {
    transform: scale(0.9);
  }
  .title-left {
    font-family: SourceHanSansCN-Bold;
    font-size: 36px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
    margin: 50px 40px 0px;
  }
  .work-title {
    font-size: 28px;
  }
  .work-dec {
    font-size: 16px;
  }
}
@media (max-width: 960px) {
  .eventExhibition-act-list {
    position: relative;
  }
  .title-left {
    font-family: SourceHanSansCN-Bold;
    font-size: 26px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
    margin: 40px 0 20px;
  }
  .carousel-exhibit {
    width: 720px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .carousel-slides-exhibit {
    display: flex;
    width: 720px;
    transition: transform 0.5s ease;
    color: #000;
  }
  .carousel-slides-exhibit .exhibit-pc {
    width: 720px;
    height: 720px;
    object-fit: cover;
  }

  .carousel-slide {
    flex: 0 0 100%;
    min-width: 100%;
    text-align: center;
    padding: 20px 0;
  }

  .carousel-slide.active {
  }

  .carousel-pagination {
    position: absolute;
    left: 750px;
    bottom: 40px;
    display: flex;
    margin-top: 10px;
  }

  .carousel-pagination-button {
    margin: auto 2px !important;
    opacity: 1;
    width: 13px;
    height: 2.6px;
    background: url(../../assets/diandian_grey.png) no-repeat center;
    background-size: contain;
    cursor: pointer;
  }

  .carousel-pagination-button.active {
    width: 13px;
    height: 2.6px;
    background: none;
    position: relative;
    background: url(../../assets/diandian_highllight.png) no-repeat center;
    background-size: contain;
  }

  .carousel-control {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: #000;
    border: none;
    cursor: pointer;
    z-index: 10;
  }
  .work-info {
    width: 500px;
    height: auto;
    text-align: left;
    position: absolute;
    bottom: 80px;
    right: 24%;
    transform: translateX(160px);
  }
  .work-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 22px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
    margin-bottom: 11px;
  }
  .work-dec {
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #2c2c2c;
    letter-spacing: 0;
    text-align: left;
    line-height: 32px;
    font-weight: Regular;
  }
}
</style>